/**
 * Build the Metube web URL for "Visit our Website".
 * Forwards share params to web /share so web SharePage resolves the content.
 *
 * @param {object} queryParams - parsed search params from landing /share
 * @param {string} webBaseUrl - web SPA origin, e.g. https://metubeweb.codderlab.com/
 * @returns {string|null} absolute URL, or null if required fields missing
 */
export function buildWebDestination(queryParams = {}, webBaseUrl = "") {
  const base = String(webBaseUrl || "").replace(/\/+$/, "");
  if (!base) return null;

  const pageRoutes = queryParams.pageRoutes;
  const pageRoute = queryParams.pageRoute;
  const route = pageRoutes || pageRoute;
  const id = queryParams.id;

  // Incomplete share → do not invent a home deep link; caller may fallback
  if (!route || !id) {
    return null;
  }

  const params = new URLSearchParams();

  if (pageRoutes) params.set("pageRoutes", String(pageRoutes));
  if (pageRoute) params.set("pageRoute", String(pageRoute));
  params.set("id", String(id));

  if (queryParams.channelId) params.set("channelId", String(queryParams.channelId));
  if (queryParams.videoUrl) params.set("videoUrl", String(queryParams.videoUrl));
  if (queryParams.referralCode) params.set("referralCode", String(queryParams.referralCode));
  if (queryParams.sellerName) params.set("sellerName", String(queryParams.sellerName));
  if (queryParams.title) params.set("title", String(queryParams.title));

  // Optional legacy passthrough
  if (queryParams.userId) params.set("userId", String(queryParams.userId));
  if (queryParams.episodeNumber) params.set("episodeNumber", String(queryParams.episodeNumber));
  if (queryParams.movieName) params.set("movieName", String(queryParams.movieName));
  if (queryParams.roomId) params.set("roomId", String(queryParams.roomId));
  if (queryParams.liveUserId) params.set("liveUserId", String(queryParams.liveUserId));

  return `${base}/share?${params.toString()}`;
}
